import { z } from 'zod/v4';

export const notifyAssetResultSchema = z.object({
  errorCode: z.string().nullable(),
  totalMessagesSent: z.number(),
  totalMessageFailures: z.number(),
});

export type NotifyAssetResult = z.infer<typeof notifyAssetResultSchema>;
